import { ReportTypes } from '../enums/report-type.enum';

export const downloadReportTypeTranslationMap = {
    [ReportTypes.LISTINGS_REPORT]: 'dashboard.downloadReports.type.listingsReport',
    [ReportTypes.DISTRIBUTION_TRACKING_REPORT]: 'dashboard.downloadReports.type.distributionTrackingReport',
    [ReportTypes.PREMIER_INN_REPORT]: 'dashboard.downloadReports.type.premierInnReport',
};
